// created from 'create-ts-index'

export * from './Footer';
export * from './FooterInformation';
export * from './FooterMenus';
